<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title mb-0">
            {{ activeLanguageTranslations?.title }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.title }}</div> -->
        <div class="static-content-paragraph">
          <!-- <b> {{ activeLanguageTranslations?.sggsProject }} </b> <br />
          {{ activeLanguageTranslations?.subTagLine }} -->
        </div>

        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.theVision }}</div> -->
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph1 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph2 }}
        </div>
         
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph3 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph4 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph5 }}
        </div>
        
        <div class="static-content-paragraph">
          <p class="left-padding">
            {{ activeLanguageTranslations?.Paragraph6_1 }}
            <a href="{{ activeLanguageTranslations?.Link6  }}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.Link6 }}</a>
          </p>
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph7 }}
        </div>
        
        <div class="static-content-paragraph">
          <p class="left-padding">
          {{ activeLanguageTranslations?.Paragraph8_1 }}
          <a href="{{ activeLanguageTranslations?.Link8  }}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.Link8 }}</a>
          {{ activeLanguageTranslations?.Paragraph8_2 }}
          </p>
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph9 }}
        </div>
        
        <div class="static-content-paragraph">
          <p class="left-padding">
          {{ activeLanguageTranslations?.Paragraph10_1 }}
          <a href="{{ activeLanguageTranslations?.Link10  }}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.Link10 }}</a>
          {{ activeLanguageTranslations?.Paragraph8_2 }}
        </p>
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph11 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph12 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph13_1 }} <a class="know-more" href="mailto:{{activeLanguageTranslations?.Email13}} ">{{activeLanguageTranslations?.Email13}} </a> {{ activeLanguageTranslations?.Paragraph13_2 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph14 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph15_1 }} <a class="know-more" href="mailto:{{activeLanguageTranslations?.Email15}} ">{{activeLanguageTranslations?.Email15}}</a>.
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph16 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph17 }}<br/>
          <a href="{{ activeLanguageTranslations?.Link18 }}" target="_blank" class="view-more-link">{{ activeLanguageTranslations?.Link18 }}</a><br/>
          {{ activeLanguageTranslations?.Paragraph19 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.Paragraph20 }}
        </div>


        
      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
